import { Recipe } from '../../../api/Recipe';

export interface HomeRecipeFeedState {
  displayedRecipes: Recipe[];
  showDailySelection: boolean;
  showEmptyState: boolean;
}

interface DeriveHomeRecipeFeedStateParams {
  allRecipes: Recipe[];
  dailySelectionRecipe: Recipe | null;
  hasMore: boolean;
  isRefreshing: boolean;
  loading: boolean;
  isLoadingTags: boolean;
  isLoadingAuthors: boolean;
}

export const prependDailySelectionRecipe = (
  recipes: Recipe[],
  dailySelectionRecipe: Recipe | null
): Recipe[] => {
  if (!dailySelectionRecipe) {
    return recipes;
  }

  return [
    dailySelectionRecipe,
    ...recipes.filter((recipe) => recipe.id !== dailySelectionRecipe.id),
  ];
};

export const shouldShowHomeEmptyState = ({
  displayedRecipes,
  hasMore,
  isRefreshing,
  loading,
  isLoadingTags,
  isLoadingAuthors,
}: {
  displayedRecipes: Recipe[];
  hasMore: boolean;
  isRefreshing: boolean;
  loading: boolean;
  isLoadingTags: boolean;
  isLoadingAuthors: boolean;
}) =>
  displayedRecipes.length === 0 &&
  !hasMore &&
  !isRefreshing &&
  !loading &&
  !isLoadingTags &&
  !isLoadingAuthors;

export const deriveHomeRecipeFeedState = ({
  allRecipes,
  dailySelectionRecipe,
  hasMore,
  isRefreshing,
  loading,
  isLoadingTags,
  isLoadingAuthors,
}: DeriveHomeRecipeFeedStateParams): HomeRecipeFeedState => {
  const displayedRecipes = prependDailySelectionRecipe(allRecipes, dailySelectionRecipe);

  return {
    displayedRecipes,
    showDailySelection: Boolean(dailySelectionRecipe),
    showEmptyState: shouldShowHomeEmptyState({
      displayedRecipes,
      hasMore,
      isRefreshing,
      loading,
      isLoadingTags,
      isLoadingAuthors,
    }),
  };
};
